
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class ContactService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/contacts',query);
    }

    create(body: any) {
        return this.post('/contact',body);
    }

    find(id) {
        return this.get('/contact/'+id);
    }

    update(id, body) {
        return this.put('/contact/'+id, body);
    }

    deleteContact(id) {
        return this.delete('/contact/'+id);
    }

    findByPhone(phone) {
        return this.get('/find-by-phone/'+phone);
    }


    findByFacebook(fb_id) {
        return this.get('/contact-facebook/'+fb_id)
    }

    findInAll(query?:any) {
        return this.get('/find-user',query);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Contact.service.ts